import React, { useEffect, useState } from "react";
import ImageWrapper from "components/ImageWrapper";
import RightArrowIcon from "components/icons/RightArrowIcon";
import LeftArrowIcon from "components/icons/LeftArrowIcon";
import { useSwipeable } from "react-swipeable";
import { getThumbnail } from "../sharedUtils/postFunctions";
import CameraIcon from "components/icons/CameraIcon";

/**
 * 
 * @param {{images:{url:string, role:Number}[], customClass:string, imageStyle:object}} props
 */
const PostBanner = (props) => {

    let [currentMedia, setMedia] = useState(0);
    let [images, setImages] = useState(props.images);
    let [isEditing, setIsEditing] = useState(props.isEditing);

    useEffect(() => {
        setImages([...props.images].reverse());
    }, [props.images])

    const mediaPageHandlers = useSwipeable({
        onSwipedLeft: () => nextMedia(),
        onSwipedRight: () => prevMedia(),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    });

    let nextMedia = () => {
        if (currentMedia < images.length - 1) {
            let newMedia = currentMedia + 1;
            setMedia(newMedia);
        }
        else {
            setMedia(0);
        }
    }

    let prevMedia = () => {
        if (currentMedia > 0) {
            let newMedia = currentMedia - 1;
            setMedia(newMedia);
        }
        else {
            setMedia(images.length - 1);
        }
    }

    let postIndicators = () => {
        return images.map((pic, i) => {
            return (
                <li
                    className={`${currentMedia === i ? "active" : ""}`}
                    key={i}
                    onClick={() => setMedia(i)} // ← navigate to this image
                    style={{
                        backgroundColor: "black",
                        width: "7px",
                        height: "7px",
                        borderRadius: "100%",
                        cursor: "pointer", // add hover indicator
                        margin: "0 4px", // optional spacing
                    }}
                />
            );
        });
    };


    return (
        <div className={`text-center ${props.customClass || ""} post-page-banner`} style={ props.postPageBannerStyle ?? {} }>


            <div className="carousel slide">
                
                <div {...mediaPageHandlers} className="carousel-inner post-banner-media-wrapper">
                    <ImageWrapper
                        src={images[currentMedia]?.url || "images/blank-banner.png"}
                        className={`post-banner-media${props.blogEmbed  ? "-blog-embed" : ""}`}
                        alt="Responsive"
                        postBanner={true}
                        role={images[currentMedia]?.role}
                        poster={getThumbnail(props.properties, props.images[currentMedia]?.id)}
                        width={images[currentMedia]?.width}
                        height={images[currentMedia]?.height}
                        style={props?.imageStyle}
                        onClick={props.onClick}
                        postPage={props.postPage}
                        setVideoLoaded={props.setVideoLoaded}
                        size="Post"
                    />
                    <input type="file"
                        accept="image/png,image/jpeg"
                        name="files[]"
                        id="uploadLockerImage"
                        onChange={(e) => props.selectMediaToUpload(e)}
                        style={{ display: "none" }}
                    />
                </div>
                {
                    props.images.length < 2  && isEditing === true ? (
                        <>
                            <button
                                id="cameraButton"
                                className="btn btn-secondary position-absolute"
                                style={{ zIndex: 3, bottom: "6px", transform: "translate(-50%, 0)", }}
                                onClick={(e) => {
                                    document.getElementById("uploadLockerImage").click()
                                }}
                            >
                                <CameraIcon className="mb-1" />
                                {props.deviceSize === "sm" ? "" : " Add Image"}
                            </button>
                        </>

                    ) : null
                }

                {
                    props.images.length > 1 ? (
                        <>
                            <a
                                href="/"
                                className="left-arrow position-absolute d-flex justify-content-center align-items-center"
                                style={props.leftArrowStyle ?? {}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    prevMedia()
                                }}
                            >
                                <span>
                                    <LeftArrowIcon x={16} y={16}/>
                                </span>
                            </a>

                            <div className="position-relative">

                                {
                                    isEditing === true ? (
                                        <>
                                            <button
                                                id="cameraButton"
                                                className="btn btn-secondary position-absolute"
                                                style={{ zIndex: 3, bottom: "33px", transform: "translate(-50%, 0)", }}
                                                onClick={(e) => {
                                                    document.getElementById("uploadLockerImage").click()
                                                }}
                                            >
                                                <CameraIcon className="mb-1"/>
                                                {props.deviceSize === "sm" ? "" : " Add Image"}
                                            </button>
                                        </>

                                    ) : null
                                }
                                <ol className="post-banner-indicators carousel-indicators mb-0">
                                    {postIndicators()}
                                </ol>
                            </div>

                            <a
                                href="/"
                                className="right-arrow position-absolute d-flex justify-content-center align-items-center"
                                style={props.rightArrowStyle ?? {}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    nextMedia()
                                }}
                            >
                                <span>
                                    <RightArrowIcon x={16} y={16}/>
                                </span>
                            </a>
                        </>
                    ) : null
                }
            </div>
            
        </div>

    )
}

export default PostBanner;